import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Table,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import { FormEvent, useState } from "react";
import { MdDelete } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAddCourseData } from "redux/slices/AddCourseSlice";
import { getCourses } from "redux/slices/coursesSlice";
import {
  selectUpdateFormationData,
  setCourses,
  setQuestionToUpdate,
} from "redux/slices/updateFormationSlice";
import AddCourse from "views/admin/formations/add/components/course/AddCourse";
import UpdateSingleCourseModal from "./UpdateSingleCourseModal";
//import AddQuestion from "./AddQuestion"

interface UpdateCourseProps {
  submitHandler: (e: React.FormEvent) => void;
  formationId: number;
  courseId: number;
  setCourseId: React.Dispatch<React.SetStateAction<number>>;
}
const UpdateCourseModal: React.FC<UpdateCourseProps> = ({
  submitHandler,
  courseId,
  setCourseId,
  formationId,
}: UpdateCourseProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useAppDispatch();
  const courses = useAppSelector(getCourses).courses.filter(
    (item) => item.formationId === formationId
  );
  const { title, description, image, ressource, ressourceType } =
    useAppSelector(getAddCourseData);
  const questions = useAppSelector(selectUpdateFormationData).testQuestions;
  const formationToUpdate = useAppSelector(
    selectUpdateFormationData
  ).formationToUpdate;
  const [id, setId] = useState(0);
  const courseToUpdate = useAppSelector(
    selectUpdateFormationData
  ).courseToUpdate;
  const toast = useToast();
  const deleteCourse = async (id: number) => {
    try {
      const res = await axios.delete(`${apiurl}/course/${id}`);
      dispatch(setCourses(courses.filter((item) => item.id != res.data.id)));
      toast({
        title: "Succés de suppression de cours",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Erreur de suppression de cours",
        status: "error",
      });
    }
  };
  const addCourseSubmitHandler = async (e: React.FormEvent) => {
    try {
      const res = await axios.post(`${apiurl}/course`, {
        title,
        description,
        lastModifiedOn: null,
        image,
        ressource,
        ressourceType,
        formationId: formationToUpdate.id,
      });
      dispatch(setCourses([...courses, res.data]));
      setId(id + 1);
      toast({
        title: "Succés d'ajout de cours",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Erreur d'ajout de cours",
        status: "error",
      });
    }
  };
  const updateCourseSubmitHandler = async (e: React.FormEvent, id: number) => {
    e.preventDefault();
    try {
      const res = await axios.patch(`${apiurl}/course/${id}`, {
        title: courseToUpdate.title,
        description: courseToUpdate.description,
        lastModifiedOn: new Date(),
        image: courseToUpdate.image,
      });
      dispatch(setCourses([...courses, res.data]));
      setId(id + 1);
      toast({
        title: "Succés de modification de cours",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Erreur de modification de cours",
        status: "error",
      });
    }
  };
  const setState = (id: number) => {
    dispatch(setQuestionToUpdate(questions.find((item) => item.id === id)));
  };

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme={"brand"} onClick={onOpen}>
        Modifier les Cours
      </Button>

      <Modal
        closeOnOverlayClick={false}
        size={"5xl"}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <form action="" onSubmit={submitHandler}>
          <ModalContent>
            <ModalHeader>Liste des cours existant</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              {/* <FormControl id="email">
  <FormLabel>Désignation de test</FormLabel>
  <Input value={test.title} onChange={(e)=>dispatch(setTest({...test,title:e.target.value}))} borderRadius={"full"} type="text" />
  
</FormControl>
<FormControl id="email">
  <FormLabel>Description</FormLabel>
  <Input value={test.description} onChange={(e)=>dispatch(setTest({...test,description:e.target.value}))} borderRadius={"full"} type="text" />
  
    </FormControl>*/}

              <Stack my={5} direction="row" spacing={"auto"}>
                <Table variant="striped" colorScheme="brand">
                  <Thead>
                    <Tr>
                      <Th>Titre</Th>
                      <Th>description</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {courses &&
                      courses.map((item) => (
                        <Tr>
                          <Td>{item.title}</Td>
                          <Td>{item.description}</Td>
                          <Td>
                            <HStack>
                              <UpdateSingleCourseModal
                                id={item.id}
                                submitHandler={function (
                                  e: FormEvent<Element>
                                ): void {
                                  updateCourseSubmitHandler(e, item.id);
                                }}
                              />
                              <IconButton
                                icon={<MdDelete />}
                                onClick={() => deleteCourse(item.id)}
                                colorScheme={"brandScheme"}
                                aria-label={""}
                              />
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                  </Tbody>
                  <Tfoot>
                    <Tr>
                      <Th>Contenu</Th>
                    </Tr>
                  </Tfoot>
                </Table>
                <AddCourse id={id} submitHandler={addCourseSubmitHandler} />
              </Stack>
            </ModalBody>

            <ModalFooter>
              <Button
                type="button"
                onClick={(e) => {
                  submitHandler(e);
                  onClose();
                }}
                colorScheme="brand"
                mr={3}
              >
                Enregistrer
              </Button>
              <Button onClick={onClose}>Annuler</Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>
    </>
  );
};

export default UpdateCourseModal;
